<template>
    <el-dialog v-dialogDrag class="captcha-image im-dialog-shell im-dialog-shell--sm im-dialog-shell--mobile-center" title="验证" :width="dialogWidth" :visible.sync="isShow" 
        :before-close="onClose" :close-on-click-modal="false" :z-index="99">
        <el-form :model="formData" :rules="rules" ref="captchaForm">
            <el-form-item prop="code">
                <img class="img" :style="captchaImageStyle" :src="captchaImage" @click="loadCaptchaImage">
                <el-input v-model="formData.code" placeholder="请输入图中验证码，仅限字母和数字"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="onClose()">取 消</el-button>
            <el-button type="primary" @click="onOk()">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { sanitizeAlphaNumeric, validateCaptchaCode } from '../../utils/authValidators';

export default {
    name: "captchaImage",
    props: {
        dialogWidth: {
            type: String,
            default: '400px'
        },
        imageMaxWidth: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isShow: false,
            id: '',
            captchaImage: '',
            callback: null,
            formData: {
                code: ''
            },
            rules: {
                code: [
                    { validator: validateCaptchaCode, trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        captchaImageStyle() {
            if (!this.imageMaxWidth) {
                return {};
            }

            return {
                maxWidth: this.imageMaxWidth,
                marginLeft: 'auto',
                marginRight: 'auto'
            };
        }
    },
    methods: {
        open(callback) {
            this.isShow = true;
            this.callback = callback;
            this.formData.code = ''; 
            this.loadCaptchaImage();
        },
        onClose() {
            this.isShow = false;
        },
        loadCaptchaImage() {
            this.$http({
                url: "/captcha/img/code",
                method: 'post'
            }).then((data) => {
                this.id = data.id;
                this.captchaImage = 'data:image/gif;base64,' + data.image;
            })
        },
        onOk() {
            this.$refs.captchaForm.validate((valid) => {
                if (valid) {
                    this.$http({
                        url: '/captcha/img/vertify',
                        method: 'post',
                        data: {
                            id: this.id,
                            code: this.formData.code
                        }
                    }).then((isPass) => {
                        if (!isPass) {
                            this.$message.error("验证码错误")
                        } else {
                            this.callback && this.callback( this.id, this.formData.code);
                            this.onClose();
                        }
                    })
                }
            });
        }
    },
    watch: {
        'formData.code'(value) {
            const sanitized = sanitizeAlphaNumeric(value);
            if (sanitized !== value) {
                this.formData.code = sanitized;
            }
        }
    }
}
</script>


<style lang="scss" scoped>
.captcha-image {
    .img {
        display: block;
        width: 100%;
        border-radius: 8px;
        border: 1px solid var(--im-control-border);
        background: var(--im-control-bg);
        cursor: pointer;
    }

    ::v-deep .el-form-item {
        margin-bottom: 0 !important;
    }

    ::v-deep .el-input {
        margin-top: 10px;
    }
}
</style>
